import React, { useState } from 'react';
import { apiJson } from '../apiClient';
import './SecurityPages.css';

const SecurityChangePasswordPage = ({ onNavigate }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
  const [message, setMessage] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    if (newPassword !== newPasswordRepeat) {
      setMessage({ type: 'error', text: 'New passwords do not match.' });
      return;
    }
    if (newPassword.length < 8) {
      setMessage({ type: 'error', text: 'New password must be at least 8 characters.' });
      return;
    }
    setBusy(true);
    try {
      await apiJson('/me/password', {
        method: 'POST',
        body: JSON.stringify({
          currentPassword,
          newPassword,
          newPasswordRepeat,
        }),
      });
      setCurrentPassword('');
      setNewPassword('');
      setNewPasswordRepeat('');
      setMessage({ type: 'success', text: 'Password updated successfully.' });
    } catch (err) {
      setMessage({ type: 'error', text: err?.message || 'Could not update password.' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="security-page page-bleed">
      <header className="security-page-head">
        <button type="button" className="security-back" onClick={() => onNavigate?.('overview')}>
          ← Dashboard
        </button>
        <h1 className="security-title">Change password</h1>
        <p className="security-lead">Use a strong password you do not reuse on other sites.</p>
      </header>
      <form className="security-form" onSubmit={handleSubmit}>
        <label className="security-field">
          <span>Current password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required
            disabled={busy}
          />
        </label>
        <label className="security-field">
          <span>New password (min 8 characters)</span>
          <input
            type="password"
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            disabled={busy}
          />
        </label>
        <label className="security-field">
          <span>Confirm new password</span>
          <input
            type="password"
            autoComplete="new-password"
            value={newPasswordRepeat}
            onChange={(e) => setNewPasswordRepeat(e.target.value)}
            required
            minLength={8}
            disabled={busy}
          />
        </label>
        <button type="submit" className="security-submit" disabled={busy}>
          {busy ? 'Saving…' : 'Update password'}
        </button>
        {message?.type === 'success' ? <div className="security-msg security-msg--ok">{message.text}</div> : null}
        {message?.type === 'error' ? <div className="security-msg security-msg--err">{message.text}</div> : null}
      </form>
    </div>
  );
};

export default SecurityChangePasswordPage;
